import React, {useState} from 'react';
import { classNames } from '../../../Services/helpers';

const CustomSelect = ({options, selected, onChange, name = 'select-group', isDisabled = false}) => {
    const [value, setValue] = useState(selected ?? null);

    const change = (value) => {
        setValue(value);
        onChange && onChange(value);
    }

    return <div className="flex flex-col space-y-1 my-2">
        {options.map((option, index) => <div key={option.value}
                className={classNames(
                    'relative flex items-center p-2 rounded border',
                    value === option.value ? 'border-brand' : 'border-transparent'
                )}
            >
            <div className="flex shrink-0">
                <input
                    id={'radio-'+option.value}
                    aria-describedby={'desc-'+option.value}
                    name={name}
                    type="radio"
                    value={option.value}
                    className="h-4 w-4 rounded-full border-gray-300 text-brand focus:ring-brand"
                    checked={value === option.value}
                    onChange={() => change(option.value)}
                    disabled={isDisabled}
                />
            </div>
            <label className="grow block ml-3" htmlFor={'radio-'+option.value}>
                {option.body}
            </label>
        </div>)}
    </div>
}

export default CustomSelect;